import { render, staticRenderFns } from "./Detail-Invoice.vue?vue&type=template&id=872f5cdc&scoped=true"
import script from "./Detail-Invoice.vue?vue&type=script&lang=js"
export * from "./Detail-Invoice.vue?vue&type=script&lang=js"
import style0 from "./Detail-Invoice.vue?vue&type=style&index=0&id=872f5cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872f5cdc",
  null
  
)

export default component.exports